
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Icon from '../ui/AppIcon';
import './StickyAnchorNav.css'
import Enquiry_Form_Modal from '../../app/enquiry_form_modal/Enquiry_Form_Modal';


interface NavSection {
  id: string;
  label: string;
  anchor: string;
  description?: string;
}

interface StickyAnchorNavProps {
  isOpen?: boolean;
  onToggle?: () => void;
}

const StickyAnchorNav = ({ isOpen = false, onToggle }: StickyAnchorNavProps) => {
  const [activeSection, setActiveSection] = useState<string>('');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(isOpen);
  const [scrollProgress, setScrollProgress] = useState(0);
      const [showStickyModal, setShowStickyModal] = useState(false);

  const navSections: NavSection[] = [
    // {
    //   id: 'program-overview',
    //   label: 'Program Overview',
    //   anchor: '#program-overview',
    //   description: 'Learn about our MBA program benefits',
    // },
    {
      id: 'specializations',
      label: 'Specializations',
      anchor: '#specializations',
      description: 'Explore MBA tracks for your career',
    },
    {
      id: 'fees-emi',
      label: 'Fees & EMI',
      anchor: '#fees-emi',
      description: 'Transparent pricing and payment options',
    },
    // {
    //   id: 'success-stories',
    //   label: 'Success Stories',
    //   anchor: '#success-stories',
    //   description: 'Real outcomes from working professionals',
    // },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);

      // Calculate scroll progress
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const currentProgress = scrollHeight > 0 ? (window.scrollY / scrollHeight) * 100 : 0;
      setScrollProgress(Math.min(currentProgress, 100));

      const sections = navSections.map((section) => {
        const element = document.querySelector(section.anchor);
        if (element) {
          const rect = element.getBoundingClientRect();
          return {
            id: section.id,
            top: rect.top,
            bottom: rect.bottom,
          };
        }
        return null;
      }).filter(Boolean);

      const current = sections.find(
        (section) => section && section.top <= 150 && section.bottom > 150
      );

      if (current) {
        setActiveSection(current.id);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(isOpen);
  }, [isOpen]);

  const handleNavClick = (anchor: string, sectionId: string) => {
    const element = document.querySelector(anchor);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
      setActiveSection(sectionId);
      setIsMobileMenuOpen(false);
      if (onToggle) onToggle();
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (onToggle) onToggle();
  };

 

  

  return (
    <>
      <nav
        className={`w-full bg-background border-b border-border transition-all duration-300 ${
          isScrolled ? 'fixed top-0 left-0 right-0 z-nav shadow-md' : 'relative'
        }`}
      >
        <div className="max-w-content mx-auto px-section-margin">
          <div className="flex items-center justify-between h-20">
        
            <div className="flex items-center space-x-4">
              <Link to="/" className="flex items-center space-x-3">

                <div className='logo_holder'>
                  <img src='/assets/images/logo/logo.png' className='logo'/>
                </div>
                {/* <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                  <span className="text-primary-foreground font-bold text-xl">DY</span>
                </div>
                <div className="hidden sm:block">
                  <div className="text-text-primary font-bold text-lg leading-tight">
                    DY Patil
                  </div>
                  <div className="text-text-secondary text-sm">Online MBA</div>
                </div> */}
              </Link>

              {/* Accreditation Badges */}
              {/* <div className="hidden md:flex items-center space-x-3 ml-6 pl-6 border-l border-border">
                <div className="flex items-center space-x-1 bg-muted px-3 py-1 rounded-md">
                  <Icon name="CheckBadgeIcon" size={16} className="text-success" variant="solid" />
                  <span className="text-xs font-semibold text-text-primary">UGC Approved</span>
                </div>
                <div className="flex items-center space-x-1 bg-muted px-3 py-1 rounded-md">
                  <Icon name="StarIcon" size={16} className="text-warning" variant="solid" />
                  <span className="text-xs font-semibold text-text-primary">NAAC A++</span>
                </div>
              </div> */}
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-nav-spacing">
              {navSections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => handleNavClick(section.anchor, section.id)}
                  className={`text-base font-medium transition-default px-3 py-2 rounded-md ${
                    activeSection === section.id
                      ? 'text-primary bg-primary/10' :'text-text-secondary hover:text-primary hover:bg-muted'
                  }`}
                  title={section.description}
                >
                  {section.label}
                </button>
              ))}
              <div
                   onClick={() => {setShowStickyModal(true)}}
                className="ml-4 bg-accent text-accent-foreground px-6 py-3 rounded-lg font-semibold shadow-cta hover:bg-accent/90 transition-default"
              >
                Apply Now
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="flex items-center space-x-3 lg:hidden">
              <a
                href="#apply-now"
                className="bg-accent text-accent-foreground px-4 py-2 rounded-lg font-semibold text-sm shadow-cta"
              >
                Apply
              </a>
              <button
                onClick={toggleMobileMenu}
                className="p-2 rounded-md text-text-secondary hover:text-primary hover:bg-muted transition-default"
                aria-label="Toggle menu"
              >
                <Icon
                  name={isMobileMenuOpen ? 'XMarkIcon' : 'Bars3Icon'}
                  size={24}
                  variant="outline"
                />
              </button>
            </div>
          </div>
        </div>

        {/* Scroll Progress Indicator */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-muted">
          <div
            className="h-full bg-primary transition-all duration-300"
            style={{
              width: `${scrollProgress}%`,
            }}
          />
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-mobile-menu lg:hidden"
          onClick={toggleMobileMenu}
        >
          <div
           className="fixed inset-0 m-auto w-80 max-w-full h-fit bg-background shadow-xl overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="p-6 space-y-1">
              {/* Mobile Accreditation Badges */}
              {/* <div className="flex flex-wrap gap-2 mb-6 pb-6 border-b border-border">
                <div className="flex items-center space-x-1 bg-muted px-3 py-2 rounded-md">
                  <Icon name="CheckBadgeIcon" size={16} className="text-success" variant="solid" />
                  <span className="text-xs font-semibold text-text-primary">UGC Approved</span>
                </div>
                <div className="flex items-center space-x-1 bg-muted px-3 py-2 rounded-md">
                  <Icon name="StarIcon" size={16} className="text-warning" variant="solid" />
                  <span className="text-xs font-semibold text-text-primary">NAAC A++</span>
                </div>
              </div> */}

              {navSections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => handleNavClick(section.anchor, section.id)}
                  className={`w-full text-left px-4 py-3 rounded-lg transition-default ${
                    activeSection === section.id
                      ? 'bg-primary/10 text-primary font-semibold' :'text-text-primary hover:bg-muted'
                  }`}
                >
                  <div className="font-medium">{section.label}</div>
                  {section.description && (
                    <div className="text-sm text-text-secondary mt-1">{section.description}</div>
                  )}
                </button>
              ))}

              <div className="pt-6 mt-6 border-t border-border">
                <a
                  href="#apply-now"
                  className="block w-full bg-accent text-accent-foreground text-center px-6 py-4 rounded-lg font-semibold shadow-cta hover:bg-accent/90 transition-default"
                  onClick={toggleMobileMenu}
                >
                  Apply Now - Free Counseling
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      
  <Enquiry_Form_Modal
          show={showStickyModal}
          onHide={() => {
            setShowStickyModal(false);
          }}
        />

    </>
  );
};

export default StickyAnchorNav;